/**
 * Emit hosts for the `global-config` analytics group — 5 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

export function trackFindReplaceDocumentEdited({ sessionId }: { sessionId: string }) {
  trackLegacyEvent({
    name: SegmentObjectName.GlobalConfig,
    props: {
      action: SegmentActionName.FindReplaceDocumentEdited,
      sessionId: sessionId,
    },
  });

  // V2
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.DocumentUpdated,
    props: {
      session_id: sessionId,
      update_action: 'find_replace_document_edited',
    },
  });
}

export function trackFindReplaceModalSubmitted() {
  trackLegacyEvent({
    name: SegmentObjectName.GlobalConfig,
    props: {
      action: SegmentActionName.FindReplaceModalSubmitted,
    },
  });

  // V2
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.DocumentUpdated,
    props: {
      update_action: 'find_replace_submitted',
    },
  });
}

export function trackFindReplaceScopeAllTabsSelected() {
  trackLegacyEvent({
    name: SegmentObjectName.GlobalConfig,
    props: {
      action: SegmentActionName.FindReplaceScopeAllTabsSelected,
    },
  });

  // V2
  track({
    event_name: TrackingEventName.SettingsUpdated,
    props: {
      update_action: 'find_replace_scope_all_tabs',
    },
  });
}

export function trackFindReplaceScopeEverywhereSelected() {
  trackLegacyEvent({
    name: SegmentObjectName.GlobalConfig,
    props: {
      action: SegmentActionName.FindReplaceScopeEverywhereSelected,
    },
  });

  // V2
  track({
    event_name: TrackingEventName.SettingsUpdated,
    props: {
      update_action: 'find_replace_scope_everywhere',
    },
  });
}

export function trackFindReplaceScopeJustNoteSelected() {
  trackLegacyEvent({
    name: SegmentObjectName.GlobalConfig,
    props: {
      action: SegmentActionName.FindReplaceScopeJustNoteSelected,
    },
  });

  // V2
  track({
    event_name: TrackingEventName.SettingsUpdated,
    props: {
      update_action: 'find_replace_scope_just_note',
    },
  });
}
